import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

export interface CustomPickerOptions {
  disabledOptions?: string[];
}

export const CustomPicker = ({
  formData,
  onChange,
  rawErrors,
  required,
  disabled,
  readonly,
  schema,
  uiSchema,
}: FieldExtensionComponentProps<string, CustomPickerOptions>) => {
  const options = (schema.enum as string[] | undefined) ?? [];
  const disabledOptions = uiSchema?.['ui:options']?.disabledOptions ?? [];
  const hasError = Boolean(rawErrors?.length);

  return (
    <Autocomplete<string>
      options={options}
      value={formData ?? null}
      onChange={(_event, value) => value && onChange(value)}
      getOptionDisabled={option => disabledOptions.includes(option)}
      disabled={disabled || readonly}
      renderInput={params => (
        <TextField
          {...params}
          label={schema.title}
          required={required}
          error={hasError}
          helperText={hasError ? rawErrors?.join(', ') : schema.description}
        />
      )}
    />
  );
};
